<p-inputgroup class="bg-white rounded-sm h-12 w-full">
  <p-iftalabel>
    <label for="shelterSelect">Tierheim</label>
    <p-select
      [(ngModel)]="selectedShelter"
      [options]="shelters"
      (onChange)="onShelterChange($event)"
      optionLabel="title"
      dataKey="id"
      [style]="{'min-width':'180px'}"
    />
  </p-iftalabel>
</p-inputgroup>
